import iconRightArrow from '@image/icon_arrow_right.svg';
import { getJpDay } from '@js/shared/date';
import { BaseComponent } from './baseComponent';

export class OfferAllDatesInfoWindowListItem extends BaseComponent {
  static readonly tagName = 'offer-all-dates-info-window-list-item';
  static readonly checkAttributes = [
    'recruiter-name',
    'nearest-offer-start-at',
    'other-offers-count',
    'hourly-pay',
    'bonus-rate',
    'link'
  ];

  constructor(params?: {
    recruiterName?: string;
    nearestOfferStartAt?: number;
    otherOffersCount?: number;
    hourlyPay?: number;
    bonusRate?: number | null;
    link?: string;
  }) {
    super();

    if (params?.recruiterName) {
      this.setAttribute('recruiter-name', params.recruiterName);
    }

    if (params?.nearestOfferStartAt) {
      this.setAttribute('nearest-offer-start-at', params.nearestOfferStartAt.toString());
    }

    if (typeof params?.otherOffersCount === 'number') {
      this.setAttribute('other-offers-count', params.otherOffersCount.toString());
    }

    if (params?.hourlyPay) {
      this.setAttribute('hourly-pay', params.hourlyPay.toString());
    }

    const bonusRate = params?.bonusRate;
    if (typeof bonusRate === 'number' && bonusRate > 0) {
      this.setAttribute('bonus-rate', bonusRate.toString());
    }

    if (params?.link) {
      this.setAttribute('link', params.link);
    }
  }

  protected reader() {
    const recruiterName = this.getAttribute('recruiter-name') || '';
    const nearestOfferStartAt = Number(this.getAttribute('nearest-offer-start-at'));
    const otherOffersCount = Number(this.getAttribute('other-offers-count') || 0);
    const hourlyPay = Number(this.getAttribute('hourly-pay') || 0);
    const bonusRate = Number(this.getAttribute('bonus-rate') || 0);
    const link = this.getAttribute('link') || '#';
    const hasMultipleOffers = otherOffersCount > 0;
    const hasBonus = bonusRate > 0;
    const date = new Date(nearestOfferStartAt * 1000);
    const label = hasMultipleOffers ? '最短求人日' : '求人日';
    const monthDay = `${date.getMonth() + 1}/${date.getDate()}`;
    const day = `(${getJpDay(date)})`;
    const bonusHtml = hasBonus
      ? `<div data-bonus class="w-fit flex min-h-5 px-1 py-0.5 bg-error justify-center items-center text-center text-white font-semibold text-sm">${bonusRate}%UP</div>`
      : '';
    const hourlyPayHtml = `<span data-hourly-pay class="leading-5 flex items-baseline gap-x-2 ${hasBonus ? 'text-error' : 'text-lightblack'}"><span class="text-xs font-light">時給</span><span data-hourly-pay-amount class="text-sm font-normal">¥${hourlyPay.toLocaleString()}</span></span>`;

    this.classList.add('flex', 'pt-4', 'pb-2');

    this.innerHTML = `
      <a tabindex="-1" class="text-lightblack w-full flex items-stretch" data-turbo-frame="_top" href="#">
        <div class="flex min-w-0 flex-1 flex-col justify-start">
          <span data-recruiter-name class="truncate text-xs font-light leading-5"></span>
          <span data-offer-date class="flex items-baseline gap-x-0.5 text-xs font-light leading-5 text-lightblack">
            <span>${label}</span>
            <span data-offer-month-day class="text-sm font-normal">${monthDay}</span>
            <span>${day}</span>
          </span>
          ${bonusHtml}
          ${hourlyPayHtml}
        </div>
        <div class="ml-auto flex w-8 shrink-0 items-center justify-end">
          <img src="${iconRightArrow}" class="h-5 w-5 object-contain">
        </div>
      </a>
    `.trim();
    this.querySelector('[data-recruiter-name]')!.textContent = recruiterName;
    this.querySelector('a')!.setAttribute('href', link);
  }
}
